module.exports = __webpack_public_path__ + "img/internet.611d8809.png";